const HIDDEN_AUTHENTICATED_WELCOME_ROUTE_PREFIXES: string[] = [];

export function shouldShowAuthenticatedWelcome(pathname: string): boolean {
  return !HIDDEN_AUTHENTICATED_WELCOME_ROUTE_PREFIXES.some(
    (routePrefix) => pathname === routePrefix || pathname.startsWith(`${routePrefix}/`),
  );
}
